var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_3290_2617)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3290_2617",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint1_linear_3290_2617)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3290_2617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9078 19C36.346 19.0473 32.9465 20.497 30.4469 23.0348C27.9472 25.5725 26.549 28.9935 26.5556 32.5556C26.3522 38.1133 25.9117 44.315 23.2683 48.1106C32.3506 53.6344 40.1111 52.8889 40.1111 52.8889C40.1111 52.8889 47.8717 53.6344 56.9539 48.1106C54.0733 43.4678 53.4633 37.7744 53.6667 32.5556C53.6667 25.0661 47.6006 19 40.1111 19H39.9078ZM29.47 53.9733C19.7778 56.0406 13 60.8528 13 66.4444V80H40.1111L29.9444 66.4444H21.4722M40.1111 80L46.1433 55.6339C46.1433 55.6339 43.5 56.2778 40.1111 56.2778C36.7222 56.2778 34.0789 55.6339 34.0789 55.6339M40.1111 80H67.2222V66.4444C67.2222 60.8528 60.4444 56.0406 50.7522 53.9733L58.75 66.4444H50.2778L40.1111 80Z",
    fill: "#fbfbfb"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3290_2617",
    x1: -20,
    y1: 0,
    x2: 89.6875,
    y2: 92.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBCFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3290_2617",
    x1: -20,
    y1: 0,
    x2: 89.6875,
    y2: 92.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBCFFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleUser);
export default __webpack_public_path__ + "static/media/FemaleUser.d668e5fb62644a756b70c7ebaf3367e8.svg";
export { ForwardRef as ReactComponent };